/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { QuickEntitlement } from '../entitlements/models';
import { SEASON } from '../entitlements/knownEntitlementAttributes';
import { isNilOrEmpty } from '../../language/module';
import { attrValueFor, getDescription } from '../entitlements/module';
import { MediumText } from '../../styles/styles';
import ImmutableMap from '../../language/ImmutableMap';
import { EntitlementType } from '../../entitlementTypes/entitlementType';
import { getResource } from '../../language/resources/getResource';
import { IAppState } from '../../core/redux/IAppState';
import { useSelector } from 'react-redux';


const Entry = styled('span')`
  ${MediumText};
  color: white;
  padding: 15px 0px;
  text-align: center;
`;

/**
 * PassOverviewTable: a component that renders a table of entitlements and their season attributes. If a given
 * entitlement doesn't have a description attribute or a season attribute, 'Unknown' is used in place of the missing
 * data. If the entitlements are null or empty, uses an empty message inside the table.
 *
 * PureComponent: true
 * Redux Connected: false
 */
export const PassOverviewTable: React.FC<{
  entitlements?: QuickEntitlement[],
  allEntitlementTypes: ImmutableMap<EntitlementType> | undefined,
  extraCss?: SerializedStyles,
}> = ({ entitlements, extraCss, allEntitlementTypes }) => {
  const resources = useSelector((state: IAppState) => state.locale);

  return (
  <div css={css`background-color: black; ${extraCss};`}>
    <table css={css`border-collapse: collapse; width: 100%;`}>
      {
        !isNilOrEmpty(entitlements) && 
        <thead>
          <tr css={css`border-bottom: 1px solid white;`}>
            <th css={css`text-align: left;`}><Entry>{getResource(resources, 'PASS_OVERVIEW_SEASON')}</Entry></th>
            <th css={css`text-align: left;`}><Entry>{getResource(resources, 'PASS_OVERVIEW_NAME')}</Entry></th>
          </tr>
        </thead>
      }
      <tbody>
      {
        !isNilOrEmpty(entitlements) && entitlements!.map(item => (
          <tr key={item.entitlementId}>
            <td css={css`min-width: 115px; vertical-align: top!important;`}>
              <Entry id="entitlement-tooltip-season">{attrValueFor(SEASON, item) || getResource(resources, 'WAIVER_TABLE_UNKNOWN')}
              </Entry>
            </td>
            <td>
              <Entry
                id="entitlement-tooltip-name"
                css={css`vertical-align: top!important; word-break: break-word;`}
              >
                {getDescription(item, allEntitlementTypes)}
              </Entry>
            </td>
          </tr>
        ))
      }
      {
        isNilOrEmpty(entitlements) && <tr>
          <td css={css`text-align: left;`}><Entry css={css`text-align: left;`}>{getResource(resources, 'PASS_OVERVIEW_NO_PASSES')}</Entry></td>
        </tr>
      }
      </tbody>
    </table>
  </div>
  );
};
